import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { STUDENTLANGUAGES } from '../student-languages-list';
import { Vademecum } from '../vademecum';
import { BookingService } from '../service/booking.service';
import { HttpService } from '../service/http.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { StudentLanguage } from '../student-language';
import { LoginService } from '../security/login.service';
import { FaviconService } from '../favicon.service';
import { BrugesVndBooking } from '../bruges-vnd-booking';

@Component({
  selector: 'app-edit-deleted-booking-detail',
  templateUrl: './edit-deleted-booking-detail.component.html',
  styleUrls: ['./edit-deleted-booking-detail.component.css']
})
export class EditDeletedBookingDetailComponent implements OnInit {

  booking!: BrugesVndBooking;
  dashboardUrl!: string;
  duration!: number;
  bookingForm!: FormGroup;
  personalForm!: FormGroup;
  studentLanguages = STUDENTLANGUAGES;

  vademecum!: Vademecum;

  constructor(
    public bookingService: BookingService,
    private formBuilder: FormBuilder,
    private httpService: HttpService,
    private loginService: LoginService,
    private favicon: FaviconService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.loginService.activatedNavigationComponent = true;
    this.favicon.sbms();
   }

  ngOnInit() {
    let uuid = this.route.snapshot.paramMap.get("uuid")!;
    this.httpService.getBookingByUuid(uuid)
    .subscribe(booking => {
      this.booking = this.bookingService.bookingToBrugesVndBooking(booking);
      this.bookingService.booking = this.booking;

      this.duration = Math.round(this.booking.endDate.diff(this.booking.startDate, "weeks", true));
      this.bookingForm = this.formBuilder.group({
        firstName: { value: this.booking.student.firstName, disabled: true },
        lastName: { value: this.booking.student.lastName, disabled: true },
        startDate: { value: moment(this.booking.startDate).format("YYYY-MM-DD"), disabled: true },
        endDate: { value: moment(this.booking.endDate).format("YYYY-MM-DD"), disabled: true },
        studentLanguage: { value: this.booking.student.language, disabled: true }
      });
      this.bookingService.addBrugesInfo(this.booking).subscribe(() => {
        if(this.booking.vademecum){
          this.personalForm = this.formBuilder.group({
            studentMobile: {value: this.booking.vademecum.studentMobile, disabled: true},
            firstParentMobile: {value: this.booking.vademecum.firstParentMobile, disabled: true},
            secondParentMobile: {value: this.booking.vademecum.secondParentMobile, disabled: true},
            firstParentFirstName: {value: this.booking.vademecum.firstParentFirstName, disabled: true},
            firstParentLastName: {value: this.booking.vademecum.firstParentLastName, disabled: true},
            secondParentFirstName: {value: this.booking.vademecum.secondParentFirstName, disabled: true},
            secondParentLastName: {value: this.booking.vademecum.secondParentLastName, disabled: true}
          });
        }
      });
    },
    error => console.error(error)
    );
  }

  compareId(lang1: StudentLanguage, lang2: StudentLanguage) {
    return lang1 && lang2 ? lang1.id == lang2.id : lang1 == lang2;
  }

  restore(){
    console.log("inside restore method");
    this.confirmationService.confirm({
      message: "Are you sure that you want to restore this record?",
      accept: () => {
        this.booking.isActive = true;
        this.httpService.putBooking(this.booking)
        .subscribe(booking => {
          console.log("booking restored");
          this.router.navigate(["/management/bookings"]);
        });
      },
      reject: () => {
        return;
      },
      acceptLabel: "Yes, restore it",
      rejectLabel: "No, not sure"
    });
  }

}
